import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Simply Fixed</h3>
            <p className="text-sm">
              Professional mobile phone repair service with convenient doorstep pickup and delivery.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span className="text-sm">571-294-2187</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <span className="text-sm">Simplyfixed26@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4" />
                <span className="text-sm">Available nationwide</span>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Service Hours</h4>
            <div className="space-y-2 text-sm">
              <p>Monday - Friday: 8AM - 8PM</p>
              <p>Saturday: 9AM - 6PM</p>
              <p>Sunday: 10AM - 4PM</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          <p>&copy; 2025 Simply Fixed. All rights reserved. Professional mobile repair services.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;